import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ScriptLoaderService } from './services/script-loader.service';
import { ApiCommonService } from './services/api-common.service';
import Cookies from 'js-cookie';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { api } from './URL/api-url';
import { IdleService } from './services/idle.service'
import { CONSTANTS } from './constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  displaySideBar: any;
  title = 'customerUI';
  private analyticsIntervalId: any;
  private hasFiredLoginAnalytics = false; // NEW: tracks if we've already fired the one-time login analytics call
  routerSubscription!: Subscription;

  constructor(
    private router: Router,
    private scriptLoader: ScriptLoaderService,
    private apiCommonService: ApiCommonService,
    private http: HttpClient,
    private commonService: ApiCommonService,
    private idleService: IdleService
  ) {

  }
  ngOnInit() {
    this.scriptLoader.loadAuthorizeNetScript();
    this.apiCommonService.getIpAddress();
    const isServerDown = (sessionStorage.getItem('serverDown') === 'true') || (sessionStorage.getItem('sessionExpired') === 'true');
    const isLocalhost = location.hostname === 'localhost' || location.hostname === '127.0.0.1';


    // FIX lives here: this function is invoked on both page load AND every page/route
    // change (see NavigationEnd subscription below), so handling the "only once on
    // login" rule here naturally covers both triggers Akhil asked for.
    const startAnalyticsInterval = (isLogin: boolean = false) => {
      if (this.analyticsIntervalId) {
        clearInterval(this.analyticsIntervalId);
      }
      this.analyticsIntervalId = setInterval(() => {
        if (!isServerDown) {
          if (isLogin) {
            // On login: fire only once, then stay quiet until route changes away from login
            if (!this.hasFiredLoginAnalytics) {
              this.postAnalyticsData();
              this.hasFiredLoginAnalytics = true;
            }
          } else {
            // Not login: behave exactly as before — fire every tick, and reset the login lock
            this.hasFiredLoginAnalytics = false;
            this.postAnalyticsData();
          }
        }
        // if route is in login - make a anlytics all once in 5 mins - else 30 seconds
      }, isLogin ? 1000 * 60 * 5 : 1000 * 30);
    };


    // Listen for route changes
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.checkVersion();
        if (this.router.url.includes('login')) {

          this.idleService.startMonitoring(); // Start the timer after login or route change
        }else{
          this.handleCookiesAndReport();
        }

        let timeStamp = new Date().getTime().toString();

        this.updateTimeStamp(timeStamp)
        setTimeout(() => {
          this.updateTimeStamp(timeStamp)
        }, 1000)
        setTimeout(() => {
          this.updateTimeStamp(timeStamp)
        }, 1500)
        setTimeout(() => {
          this.updateTimeStamp(timeStamp)
        }, 2000)
        setTimeout(() => {
          this.updateTimeStamp(timeStamp)
        }, 3000)
        setTimeout(() => {
          this.updateTimeStamp(timeStamp)
        }, 4000)
        setTimeout(() => {
          // FIX: this is the line that was firing on every NavigationEnd, including
          // multiple times while still on /login. Now guarded the same way as the
          // interval — fires once on login, normal on every other route.
          const onLoginRoute = this.router.url.includes('login');

          if (!isServerDown) {
            if (onLoginRoute) {
              if (!this.hasFiredLoginAnalytics) {
                this.postAnalyticsData();
                this.hasFiredLoginAnalytics = true;
              }
            } else {
              this.hasFiredLoginAnalytics = false;
              this.postAnalyticsData();
            }
          }
          startAnalyticsInterval(onLoginRoute);
        }, 2500)
      }
    });
  }

  sideBarDisplay(value: string) {
    this.displaySideBar = JSON.parse(value);
  }

  postAnalyticsData() {
    const isServerDown = (sessionStorage.getItem('serverDown') === 'true') || (sessionStorage.getItem('sessionExpired') === 'true');
    if (isServerDown) {
      console.log('error calling analytics due to serverDown or sessionExpired')
      return;
    }
    const pageName = sessionStorage.getItem("pageName") || "Dashboard";
    const ipAddress = sessionStorage.getItem("ipaddress") || '';
    const timestamp = sessionStorage.getItem("timeStamp") || '';
    const loginEmail = sessionStorage.getItem('loginEmail') || '';
    const currentTimeStamp = new Date().getTime().toString();

    const body = {
      ipAddress,
      timestamp,
      pageName,
      gbReferer: window.location.hostname || document.referrer || '',
      pageUrl: window.location.href,
    };

    const headers = { "Content-Type": "application/json; charset=UTF-8" };

    this.http.post(`${api.commonLoginApiUrl}analytics`, body, { headers }).subscribe({
      next: async (result: any) => {
        if (result?.status === 200) {
        } else {
          await this.handleAnalyticsError(result, loginEmail, currentTimeStamp);
        }
      },
      error: async (error: any) => {
        await this.handleAnalyticsError(error, loginEmail, currentTimeStamp);
      }
    });
  }

  private async handleAnalyticsError(errorData: any, loginEmail: string, timestamp: string) {
    const errorMessage = errorData?.error?.error ?? errorData?.error ?? errorData;
    let log = { [`Network_Error_${timestamp}`]: errorMessage };
    Cookies.set([`Network_Error_${timestamp}`], errorMessage);

    const obj = {
      customerDetails: JSON.stringify({ username: loginEmail }),
      logs: JSON.stringify(log)
    };
    await this.commonService.submitReportLog(obj);
  }

  updateTimeStamp(timeStamp: any) {
    sessionStorage.setItem("timeStamp", timeStamp);
  }

  isVersionOlder(v1: string, v2: string): boolean {
    // split by . and get all the version related data in array
    const v1Parts = v1.split('.').map(Number); // current version
    const v2Parts = v2.split('.').map(Number); // api response version

    // get max length by comparing both arrays
    let len = Math.max(v1Parts.length, v2Parts.length);

    // If both versions have 4 parts, compare up to the 4th digit
    if (v1Parts.length === 4 && v2Parts.length === 4) {
      len = 4;
    } else {
      len = Math.min(len, 3); // limit comparison to the first 3 digits if not both 4-part versions
    }

    // loop through arrays and check v1 is bigger or not
    for (let i = 0; i < len; i++) {
      const a = v1Parts[i] || 0;
      const b = v2Parts[i] || 0;

      if (a < b) return true;
      if (a > b) return false;
    }

    return false; // equal versions or current verion is bigger than api response version
  }

  checkVersion() {
    console.log('check version method triggered');
    let pageReloaded = sessionStorage.getItem('pageReloaded');
    if (pageReloaded == 'true') {
      return;
    }

    try {
      this.http.post(api.commonLoginApiUrl + "/common/version", { portal: CONSTANTS.PORTAL })
        .subscribe((response: any) => {
          if (response.status == 200) {
            const currentVersion = api.version;
            const apiVersion = response.data.version;
            sessionStorage.setItem('sessionTimeOut', response.data?.sessionTimeOut ?? '10');

            if (this.isVersionOlder(currentVersion, apiVersion)) {
              sessionStorage.setItem('pageReloaded', 'true');
              window.location.replace(window.location.href);
            }
          } else {
            this.checkSignVersion();
          }
        });
    } catch (err) {
      console.error("Version check failed:", err);
      this.checkSignVersion();
    }
  }

  checkSignVersion() {
    try {
      this.http.post(api.signIn + "/common/version", { portal: CONSTANTS.PORTAL }).subscribe((response: any) => {
        if (response.status == 200) {
          const currentVersion = api.version;
          const apiVersion = response.data.version;
          sessionStorage.setItem('sessionTimeOut', response.data?.sessionTimeOut ?? '10');

          if (this.isVersionOlder(currentVersion, apiVersion)) {
            sessionStorage.setItem('pageReloaded', 'true');
            window.location.replace(window.location.href);
          }
        } else {
          console.log('error fetching version')
        }
      });
    } catch (err) {
      console.log('error fetching version')
    }
  }

  ngOnDestroy() {
    if (this.analyticsIntervalId) {
      clearInterval(this.analyticsIntervalId);
    }
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  handleCookiesAndReport() {
    const cookies = this.getAllCookies();

    if (Object.keys(cookies).length > 0) {

      const currentTimeStamp = new Date().getTime();

      // Submit cookies in report-log
      this.reportLogSubmit(
        false,                      // isMainApi
        currentTimeStamp,
        'CLIENT_COOKIE_CAPTURE',    // requestUrl (custom label)
        'N/A',                      // requestMethod
        cookies,                    // requestBody
        'Cookies captured',         // response
        false                       // isSignIn
      );

      // Clear all cookies after submitting
      this.clearAllCookies();
    }
  }

  getAllCookies(): any {
    const cookies: any = {};

    document?.cookie?.split(';')?.forEach(cookie => {
      const parts = cookie?.split('=');
      const name = parts[0]?.trim();
      const value = parts?.slice(1)?.join('='); // safer in case value contains "="

      if (name && name?.toLowerCase()?.includes('error')) {
        cookies[name] = value;
      }
    });

    return cookies;
  }

  private clearAllCookies() {
    document.cookie.split(";").forEach(cookie => {
      const name = cookie.split("=")[0].trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
    });
  }

  async reportLogSubmit(isMainApi: boolean = false, currentTimeStamp: any, requestUrl: any, requestMethod: any, requestBody: any, res: any, isSignIn: any = false) {
    console.log('reportLogSubmit', isSignIn);
    // get sessionStorage details
    const sessionStorageDetails = this.apiCommonService.getSessionStorageDetails()

    const log = {
      [`${isMainApi ? 'Admin portal ' : ''}Api failed ${currentTimeStamp}`]: {
        url: requestUrl,
        method: requestMethod,
        requestBody: requestBody,
        response: res
      },
      message: `${isMainApi ? 'Admin portal ' : ''}` + 'Api Failed'
    };
    const obj = {
      customerDetails: JSON.stringify({ ...sessionStorageDetails, Portal: 'ADMIN', version: api.version }),
      browser: '',
      systemDetails: {},
      logs: JSON.stringify(log),
      sessionDetails: '{}'
    };
    if (isSignIn) {
      await this.apiCommonService.submitReportLog(obj, true);
    } else {
      await this.apiCommonService.submitReportLog(obj);
    }
  }
}